package team.platforma.auth_di

import team.platforma.auth_data.di.authDataModule
import team.platforma.auth_domain.di.authDomainModule
import team.platforma.auth_presentable.di.authPresentationModule

fun getAuthModules() = listOf(
    authPresentationModule, authDataModule, authDomainModule
)